// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__p-27I","content":"GlobalSearch_content__3C-Fy"};